import { render, staticRenderFns } from "./CustomersCmp.vue?vue&type=template&id=47d6a0c6&scoped=true"
import script from "./CustomersCmp.vue?vue&type=script&lang=js"
export * from "./CustomersCmp.vue?vue&type=script&lang=js"
import style0 from "./CustomersCmp.vue?vue&type=style&index=0&id=47d6a0c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6a0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47d6a0c6')) {
      api.createRecord('47d6a0c6', component.options)
    } else {
      api.reload('47d6a0c6', component.options)
    }
    module.hot.accept("./CustomersCmp.vue?vue&type=template&id=47d6a0c6&scoped=true", function () {
      api.rerender('47d6a0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/CustomersCmp.vue"
export default component.exports